import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateMyOrgMutationVariables = Types.Exact<{
  orgId: Types.Scalars['Int']['input'];
}>;


export type UpdateMyOrgMutation = { __typename?: 'Mutation', updateMyOrg: { __typename?: 'BaseMutationResult', success: boolean } };


export const UpdateMyOrgDocument = gql`
    mutation UpdateMyOrg($orgId: Int!) {
  updateMyOrg(orgId: $orgId) {
    success
  }
}
    `;
export type UpdateMyOrgMutationFn = Apollo.MutationFunction<UpdateMyOrgMutation, UpdateMyOrgMutationVariables>;

/**
 * __useUpdateMyOrgMutation__
 *
 * To run a mutation, you first call `useUpdateMyOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyOrgMutation, { data, loading, error }] = useUpdateMyOrgMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUpdateMyOrgMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyOrgMutation, UpdateMyOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyOrgMutation, UpdateMyOrgMutationVariables>(UpdateMyOrgDocument, options);
      }
export type UpdateMyOrgMutationHookResult = ReturnType<typeof useUpdateMyOrgMutation>;
export type UpdateMyOrgMutationResult = Apollo.MutationResult<UpdateMyOrgMutation>;
export type UpdateMyOrgMutationOptions = Apollo.BaseMutationOptions<UpdateMyOrgMutation, UpdateMyOrgMutationVariables>;